module.exports = __webpack_public_path__ + "images/a2fa8771cd49d3c1f11fa7a1a67e4b47.png";